module.exports = __webpack_public_path__ + "static/media/App icon Watchdog.4b9981b7.png";